// extracted by mini-css-extract-plugin
export default {"formCont":"NewBot_formCont__1Q5LG","select-container":"NewBot_select-container__BZyDB","select":"NewBot_select__5euZn","disabled-select":"NewBot_disabled-select__djxpb"};